// extracted by mini-css-extract-plugin
export var content = "_ny-1";
export var fullScreen = "_ny-0";